@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.time-zone-group {
  display: flex;
  margin: 10px 0;
  flex-direction: column;
  gap: 4px;

  .time-zone-label {
    margin-right: 18px;
    font-size: 12px;
  }

  .time-zone-dropdown {
    width: 100%;
  }
}

.has-error {
  color: @timezone--error--text-color;
}
